import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import addPageBuilderComponents from './services/add-page-builder-components';
import variants from './variants';
import prepareItemForGtmEvent from './services/prepare-item-for-gtm';

export default async function load(app) {
  app.events.once('load:custom:page-builder:component', addPageBuilderComponents);
  app.events.once('load:custom:page-builder:variant', async addVariant => {
    Object.keys(variants).forEach(variantKey => {
      const variant = variants[variantKey];
      addVariant(variantKey, variant);
    });
  });

  app.events.on(
    'plugin:ecommerce-gtm-fe:item:prepare',
    async ({ client, currency, gtmItem, item, product }) =>
      prepareItemForGtmEvent({ client, currency, gtmItem, item, product })
  );

  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}

load.pluginName = PLUGIN_NAME;
